export const setGalleries = (state, payload) => {
  state.galleries = payload;
};
